exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.deno/core-js@2.6.12/~/core-js/library/modules/_wks-ext.js
// module id = 71
// module chunks = 0